import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

const HubertBadgeVariants = cva(
  clsx(
    'inline-flex max-w-max items-center',
    'rounded-md border',
    'px-2.5 py-0.5 text-xs font-semibold',
    'transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  ),
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: clsx('border border-solid border-primary-400', 'text-primary-400'),
        success: 'bg-success-100 text-success-800 border-success-200',
        'success-inverse': 'bg-success-800 text-success-100 border-success-200',
        danger: 'bg-danger-50 text-danger-800 border-danger-200',
        'danger-inverse': 'bg-danger-800 text-danger-50 border-danger-200',
        info: 'bg-info-50 text-info-800 border-info-200',
        warning: 'bg-warning-50 text-warning-900 border-warning-200',
        'evaluation-warning': 'bg-evaluation-warning text-warning-900',
        qualified: 'bg-evaluation-qualified text-success-800',
        disqualified: 'bg-evaluation-disqualified text-danger-800',
        bonus: 'bg-evaluation-bonus text-white',
      },
    },

    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof HubertBadgeVariants> {}

function HubertBadge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(HubertBadgeVariants({ variant }), className)} {...props} />;
}

export { HubertBadge };
